import { memo, useMemo } from "react";

import classes from "./styles.module.scss";
import type { IProductKeyIconsProps } from "./types";
import {
  IProductKeyIconsColorEnum,
  IProductKeyIconsSizeEnum,
  IProductKeyIconsVariantsEnum,
} from "./types";
import { getIconSize } from "./helper";

import { Icon } from "@/components/atoms/icon";

export const ProductKeyIcons = memo(function ProductKeyIcons(
  props: IProductKeyIconsProps,
) {
  const {
    iconName,
    color = IProductKeyIconsColorEnum.Primary,
    size = IProductKeyIconsSizeEnum.XXLarge,
    variant = IProductKeyIconsVariantsEnum.Stroke,
    disabled,
  } = props;

  const iconSize = useMemo(() => getIconSize(size), [size]);

  return (
    <div
      data-variant={variant}
      data-color={color}
      data-size={size}
      className={classes.productKeyIcon}
      data-disabled={disabled}
    >
      <Icon name={iconName} fontSize={iconSize} />
    </div>
  );
});
ProductKeyIcons.displayName = "ProductKeyIcons";
